const STORAGE_KEY = 'ecotex_presort_popup';
const HIDE_DAYS = 7;
const OPEN_DELAY = 4000;

const presort = {
    init() {
        this.popup = document.querySelector('[data-presort-popup]');

        if (!this.popup || this.seenRecently()) {
            return;
        }

        this.dialog = this.popup.querySelector('[role="dialog"]');

        this.popup.addEventListener('click', (e) => {
            if (e.target === this.popup || e.target.closest('[data-presort-close]')) {
                this.close();
            }
        });

        document.addEventListener('keydown', (e) => this.onKey(e));

        window.setTimeout(() => this.preload().then(() => this.open()), OPEN_DELAY);
    },

    seenRecently() {
        try {
            const seen = Number(window.localStorage.getItem(STORAGE_KEY));
            return seen > 0 && Date.now() - seen < HIDE_DAYS * 86400000;
        } catch (e) {
            return false;
        }
    },

    remember() {
        try {
            window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch (e) {
            return;
        }
    },

    preload() {
        const images = Array.from(this.popup.querySelectorAll('img'));

        images.forEach((img) => {
            img.loading = 'eager';
        });

        const decoded = Promise.all(images.map((img) => img.decode().catch(() => null)));
        const timeout = new Promise((resolve) => window.setTimeout(resolve, 4000));

        return Promise.race([decoded, timeout]);
    },

    open() {
        if (document.querySelector('.login-popup-overlay.active')) {
            return;
        }

        this.lastFocus = document.activeElement;
        this.popup.hidden = false;
        document.documentElement.classList.add('presort-lock');
        this.remember();

        this.popup.getBoundingClientRect();
        this.popup.classList.add('is-open');

        this.popup.querySelector('[data-presort-close]').focus({preventScroll: true});
    },

    close() {
        if (this.popup.hidden) {
            return;
        }

        this.popup.classList.remove('is-open');
        document.documentElement.classList.remove('presort-lock');
        window.setTimeout(() => {
            this.popup.hidden = true;
        }, 300);

        if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
            this.lastFocus.focus({preventScroll: true});
        }
    },

    onKey(e) {
        if (this.popup.hidden) {
            return;
        }

        if (e.key === 'Escape') {
            this.close();
            return;
        }

        if (e.key !== 'Tab') {
            return;
        }

        const items = Array.from(this.dialog.querySelectorAll('a[href], button'));
        const first = items[0];
        const last = items[items.length - 1];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        } else if (!this.dialog.contains(document.activeElement)) {
            e.preventDefault();
            first.focus();
        }
    },
};

export default presort;
